import { useCallback } from 'react';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useShowNotification } from 'js/components/common/Notifications';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { validatePassword } from './server';

export const useValidatePassword = () => {
    const translate = useComponentTranslations();
    const showNotification = useShowNotification({
        iconType: 'info',
        message: translate('successMessage')
    });
    const getErrorMessage = useGetErrorMessage();

    return useCallback(async ({ data }) => {
        const { password } = data;

        try {
            await validatePassword({ password });
            showNotification();
        } catch (error) {
            return getErrorMessage(error);
        }
    }, [getErrorMessage, showNotification]);
};
